import LineOrange from "../../../common/LineOrange/LineOrange";

export const WhyMobinCredit = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "#F2F4F6" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
            <h3 className="text-right mt-5"> چرا اعتبار از مبین سرمایه؟</h3>
            <LineOrange /> 
          </div>
          <div
            className="d-flex  align-items-center justify-content-center mb-5"
            style={{ minHeight: "50vh" }}
          >
            <div className="row align-items-center w-100 ">
              <div className="col-12 col-lg-6">
                <ul className="text-right">
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    اعتبار بیشتر
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    هزینه مالی کمتر
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    حفظ سابقه معاملاتی در کارگزاری پیشین
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    پشتیبانی حرفه‌ای
                  </li>
                </ul>
              </div>
              <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/2323.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
